import parse from 'date-fns/parse'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days'
import isSameDay from 'date-fns/is_same_day'

export default function expandEvents(events, includePastEvents = false) {
  return events
    .reduce((acc, event) => {
      const start = parse(event.start)
      const end = event.end ? parse(event.end) : start

      const today = new Date()
      today.setHours(0, 0, 0, 0)

      const diffTime = end.getTime() - start.getTime()
      const diffHours = diffTime / (1000 * 60 * 60)
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

      // Safety net for zero-day events
      if (diffDays === 0) diffDays = 1

      const isAllDay = event.allDay || diffHours >= 23

      // Normalize for date-only comparisons
      const normalizedStart = new Date(start)
      normalizedStart.setHours(0, 0, 0, 0)

      const normalizedEnd = new Date(end)
      normalizedEnd.setHours(0, 0, 0, 0)

      // let isMultiDay

      // if (isAllDay && diffDays === 1) {
      //   // All-day event lasting exactly one day → NOT multi-day
      //   isMultiDay = false
      // } else {
      //   isMultiDay = !isSameDay(normalizedStart, normalizedEnd)
      // }

      const isMultiDay =
        diffDays > 1 || !isSameDay(normalizedStart, normalizedEnd)

      const expandedEvents = []

      if (isMultiDay) {
        // Multi-day event expansion
        for (let d = 0; d < diffDays; d++) {
          const currentDay = addDays(normalizedStart, d)

          if (includePastEvents || currentDay >= today) {
            expandedEvents.push({
              ...event,
              start: currentDay,
              end: normalizedEnd,
              originalStart: start,
              allDay: true,
              multiDay: true,
              weekday: format(currentDay, 'dddd'),
              day: format(currentDay, 'DD'),
              number: format(currentDay, 'D'),
              month: format(currentDay, 'MMMM'),
              year: format(currentDay, 'YYYY')
            })
          }
        }
      } else {
        // Single-day event
        if (includePastEvents || normalizedStart >= today) {
          expandedEvents.push({
            ...event,
            start: start, // keep original start WITH time
            end: end,
            originalStart: null,
            allDay: isAllDay,
            multiDay: false,
            weekday: format(normalizedStart, 'dddd'),
            day: format(normalizedStart, 'DD'),
            number: format(normalizedStart, 'D'),
            month: format(normalizedStart, 'MMMM'),
            year: format(normalizedStart, 'YYYY')
          })
        }
      }

      return acc.concat(expandedEvents)
    }, [])
    .reduce((acc, e) => {
      const hasDuplicate = acc.some(
        ae =>
          ae.summary === e.summary &&
          ae.start.getTime() === e.start.getTime() &&
          ae.end.getTime() === e.end.getTime()
      )
      if (!hasDuplicate) acc.push(e)
      return acc
    }, [])
    .sort((a, b) => {
      const timeDiff = a.start.getTime() - b.start.getTime()
      if (timeDiff !== 0) return timeDiff

      const aSummary = (a.summary || '').toLowerCase()
      const bSummary = (b.summary || '').toLowerCase()

      const isAHighPriority =
        aSummary.includes('plc') || aSummary.includes('parent')
      const isBHighPriority =
        bSummary.includes('plc') || bSummary.includes('parent')

      if (isAHighPriority && !isBHighPriority) return -1
      if (!isAHighPriority && isBHighPriority) return 1

      // Fall back to alphabetical order if both have same priority
      return aSummary.localeCompare(bSummary)
    })
}
